/**
 * Members per role id. Custom roles count by `customRoleId`; everyone else
 * counts toward their built-in role, whose list id equals the role value
 * (`owner` / `admin` / `member`). System roles used to show "—" even when
 * assigned (DEV-538).
 */
export function countMembersByRole(
  members: { role?: string | null; customRoleId?: string | null }[],
  counts: Record<string, number> = {},
): Record<string, number> {
  for (const member of members) {
    const key = member.customRoleId?.trim() || member.role;
    if (key) counts[key] = (counts[key] ?? 0) + 1;
  }
  return counts;
}
